import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AlertContext from "../../../../Context/Alert/AlertContext";
import { BaseURL } from "../../../../Files/BaseURL";
import ThemeContext from "../../../../Context/theme/ThemeContext";

const ProfileOverView = () => {
  const { theme } = useContext(ThemeContext);
  const navigate = useNavigate();
  const location = useLocation();

  const [title, setTitle] = useState("");
  const [file, setFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [editId, setEditId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isInitializing, setIsInitializing] = useState(true);

  const alertContext = useContext(AlertContext);
  const { showAlert } = alertContext;

  useEffect(() => {
    try {
      const { title, file, imagePreview } = location.state || {};
      setTitle(title || "");
      setFile(file || null);
      setImagePreview(imagePreview || null);

      const searchParams = new URLSearchParams(location.search);
      const editid = searchParams.get("editid");
      setEditId(editid);
    } catch (error) {
      showAlert("Error loading portfolio data", "danger");
    } finally {
      setIsInitializing(false);
    }
  }, [location.state, location.search]);

  const handlePublish = async () => {
    if (!title.trim() || !file) {
      showAlert("Please provide both title and image", "warning");
      return;
    }

    try {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("title", title.trim());
      formData.append("image", file);

      const authToken = localStorage.getItem("p@token");
      const url = editId
        ? `${BaseURL}/api/portfolio/personal/updatepersonalportfolio/${editId}`
        : `${BaseURL}/api/portfolio/personal/create`;

      const response = await fetch(url, {
        method: editId ? "PUT" : "POST",
        body: formData,
        headers: {
          "auth-token": authToken,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Error uploading portfolio");
      }

      showAlert(
        editId
          ? "Portfolio updated successfully"
          : "Portfolio created successfully",
        "success"
      );
      navigate("/user-dashboard/profile/profile_success");
    } catch (error) {
      showAlert(error.message || "Error processing request", "danger");
      setIsLoading(false);
    }
  };

  if (isInitializing) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primarygreen"></div>
      </div>
    );
  }

  return (
    <div className="flex items-center font-pop flex-col">
      <div
        className={`rounded-2xl py-6 px-6 my-6 w-[95%] md:w-[70%] xl:w-[40%] flex flex-col gap-4   
                ${theme == "dark" ? "bg-black text-white" : "bg-white"}`}
      >
        <h1 className="font-semibold text-xl text-center">
          {editId ? "Edit Portfolio" : "Overview"}
        </h1>
        <div className="flex flex-col gap-4">
          <h3 className="font-pop text-lg font-medium truncate">
            {title || "No title provided"}
          </h3>
          <div className="flex items-center justify-center w-full">
            {imagePreview ? (
              <img
                src={imagePreview}
                alt="Portfolio Preview"
                className="h-auto w-full rounded-lg object-cover"
              />
            ) : (
              <p className="text-gray-500">No image uploaded</p>
            )}
          </div>
          <button
            className={`my-4 px-2 md:px-6 bg-green-500 hover:bg-transparent font-medium font-pop text-sm md:text-lg py-2 md:py-3 border border-black-500 hover:border-green-500 rounded-full text-white
                            ${
                              theme === "dark"
                                ? "hover:text-white"
                                : "hover:text-black"
                            }
                            ${
                              isLoading
                                ? "opacity-50 cursor-not-allowed"
                                : "cursor-pointer"
                            }`}
            onClick={handlePublish}
            disabled={isLoading}
          >
            {isLoading ? (
              <div className="flex items-center justify-center">
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
              </div>
            ) : editId ? (
              "Update"
            ) : (
              "Publish in my profile"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileOverView;
